import NotFound404 from '@/views/errors/404.vue';
import Unauthorized401 from '@/views/errors/401.vue';
import { Roles } from '@common/app.config';

const authMeta =  {
  auth: true,
  authorize: Object.keys(Roles).map((key) => Roles[key]),
};


export default [
  {
    path: '/404',
    name: 'PageNotFound',
    component: NotFound404,
    meta: authMeta,
  },
  {
    path: '/401',
    name: 'Unauthorized',
    component: Unauthorized401,
    meta: authMeta,
  },
];
